<script>
import VueContext from 'vue-context';

export default {
    name: "InventoryManagementDashBoard",

    components: {
        VueContext
    },
}
</script>
<style scoped>
@import  '~vue-context/dist/css/vue-context.css';
</style>
<template>
    <tail-base-layout>
        <template v-slot:content>
            <div class="flex flex-wrap">
                <div class="w-full p-1 my-1 text-center text-white bg-blue-500 rounded">
                    <h5 class="font-medium text-base">Inventory Management</h5>
                </div>
                <div class="w-full md:w-1/4 xl:w-1/4 p-2" 
                    v-if="$root.checkAuth(`inventory-management.quick-search.index`) ||
                        $root.checkAuth(`inventory-management.inventory.create`)">
                    <div class="bg-green-100 border-b-4 border-green-600 rounded-lg shadow-lg p-1">
                        <div class="flex flex-row items-center" @click.stop="$refs.menu0.open($event)">
                            <div class="flex-shrink pr-2">
                                <div class="rounded-full p-5 bg-green-600"><i class="fas fa-search fa-2x fa-inverse"></i></div>
                            </div>
                            <div class="flex-1 text-right md:text-center">
                                <h5 class="font-bold uppercase text-gray-600">Inventory</h5>
                            </div>
                        </div>
                    </div>
                    <vue-context ref="menu0">
                        <li class="border-b hover:bg-gray-400">
                            <router-link :to="{ name: `inventory-management.quick-search.index` }">Quick Search</router-link>
                        </li>
                        <li class="border-b hover:bg-gray-400" v-if="$root.checkAuth(`inventory-management.inventory.create`)">
                            <router-link :to="{ name: `inventory-management.inventory.create` }">Add Inventory</router-link>
                        </li> 
                        <!-- <li class="border-b hover:bg-gray-400">
                            <router-link :to="{ name: `master-data.accounts.item-collection.index` }">Inventory Grouping</router-link>
                            
                        </li> -->
                    </vue-context>
                </div>
                <div class="w-full md:w-1/4 xl:w-1/4 p-2"
                    v-if="$root.checkAuth(`inventory-management.initiate-stock-transfer.create`)">
                    <div class="bg-blue-100 border-b-4 border-blue-600 rounded-lg shadow-lg p-1">
                        <router-link :to="{ name: `inventory-management.initiate-stock-transfer.create`}">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-2">
                                    <div class="rounded-full p-5 bg-blue-600"><i class="fas fa-redo fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">Stock Transfer</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
                <div class="w-full md:w-1/4 xl:w-1/4 p-2"
                    v-if="$root.checkAuth(`inventory-management.journals.index`) || 
                        $root.checkAuth(`inventory-management.journals.create`)">
                    <div class="bg-blue-100 border-b-4 border-blue-600 rounded-lg shadow-lg p-1">
                        <div class="flex flex-row items-center" @click.stop="$refs.menu1.open($event)">
                            <div class="flex-shrink pr-2">
                                <div class="rounded-full p-5 bg-blue-600"><i class="fas fa-list fa-2x fa-inverse"></i></div>
                            </div>
                            <div class="flex-1 text-right md:text-center">
                                <h5 class="font-bold uppercase text-gray-600">Stock Journals</h5>
                            </div>
                        </div>
                        <vue-context ref="menu1">
                            <li class="border-b hover:bg-gray-400">
                                <router-link :to="{ name: `inventory-management.journals.index` }">Stock Journals</router-link>
                            </li>
                            <li class="border-b hover:bg-gray-400" v-if="$root.checkAuth(`inventory-management.journals.create`)">
                                <router-link :to="{ name: `inventory-management.journals.create` }">Add Stock Journal</router-link>
                            </li>
                        </vue-context>
                    </div>
                </div>
                <div class="w-full md:w-1/4 xl:w-1/4 p-2"
                    v-if="$root.checkAuth(`inventory-management.stock-take.index`)">
                    <div class="bg-indigo-100 border-b-4 border-indigo-600 rounded-lg shadow-lg p-1">
                        <router-link :to="{ name: `inventory-management.price-adjustment.index`}">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-2">
                                    <div class="rounded-full p-5 bg-indigo-600"><i class="fas fa-dollar-sign fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">Price Adjustment</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
                <div class="w-full md:w-1/4 xl:w-1/4 p-2"
                    v-if="$root.checkAuth(`inventory-management.stock-take.index`) || 
                        $root.checkAuth(`inventory-management.stock-take.create`)">
                    <div class="bg-orange-100 border-b-4 border-orange-600 rounded-lg shadow-lg p-1">
                        <div class="flex flex-row items-center" @click.stop="$refs.menu2.open($event)">
                            <div class="flex-shrink pr-2">
                                <div class="rounded-full p-5 bg-orange-600"><i class="fas fa-boxes fa-2x fa-inverse"></i></div>
                            </div>
                            <div class="flex-1 text-right md:text-center">
                                <h5 class="font-bold uppercase text-gray-600">Stock Take</h5>
                            </div>
                        </div>
                        <vue-context ref="menu2">
                            <li class="border-b hover:bg-gray-400">
                                <router-link :to="{ name: `inventory-management.stock-take.index` }">Stock Takes</router-link>
                            </li>
                            <li class="border-b hover:bg-gray-400">
                                <router-link :to="{ name: `inventory-management.stock-take.create` }">Add Stock Take</router-link>
                            </li> 
                            <li class="border-b hover:bg-gray-400">
                                <router-link :to="{ name: `inventory-management.stock-take-list.index` }">Advanced Stock Take</router-link>
                            </li>
                            <li class="border-b hover:bg-gray-400">
                                <router-link :to="{ name: `inventory-management.stock-take-cost-variance.index` }">Cost Variance Stock Take</router-link>
                            </li> <li class="border-b hover:bg-gray-400">
                                <router-link :to="{ name: `inventory-management.stock-take-approval-cost-variance.index` }">Cost Variance Approved Stock Take</router-link>
                            </li>
                        </vue-context>
                    </div>
                </div>
                <div class="w-full md:w-1/4 xl:w-1/4 p-2"
                    v-if="$root.checkAuth(`inventory-management.approvals.index`)">
                    <div class="bg-red-100 border-b-4 border-red-600 rounded-lg shadow-lg p-1">
                        <router-link :to="{ name: `inventory-management.approvals.index`}">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-2">
                                    <div class="rounded-full p-5 bg-red-600"><i class="fas fa-check-double fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">Approvals</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
                <div class="w-full md:w-1/4 xl:w-1/4 p-2" 
                    v-if="$root.checkAuth(`inventory-management.orders.index`)">
                    <div class="bg-green-200 border-b-4 border-green-600 rounded-lg shadow-lg p-1">
                        <router-link :to="{ name: `inventory-management.orders.index`}">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-2">
                                    <div class="rounded-full p-5 bg-green-600">
                                        <i class="fas fa-hands fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">Orders</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
                

                  <div class="w-full md:w-1/4 xl:w-1/4 p-2">
                    <!-- v-if="$root.checkAuth(`inventory-management.stock-take.index`) || 
                        $root.checkAuth(`inventory-management.stock-take.create`)"> -->
                    <div class="bg-red-100 border-b-4 border-red-600 rounded-lg shadow-lg p-1">
                        <div class="flex flex-row items-center" @click.stop="$refs.menu6.open($event)">
                            <div class="flex-shrink pr-2">
                                <div class="rounded-full p-5 bg-red-600"><i class="fas fa-check-double fa-2x fa-inverse"></i></div>
                            </div>
                            <div class="flex-1 text-right md:text-center">
                                <h5 class="font-bold uppercase text-gray-600">Stock Reports</h5>
                            </div>
                        </div>
                        <vue-context ref="menu6">
                            <li class="border-b hover:bg-gray-400"  v-if="$root.checkAuth(`inventory-management.stock-level-perstore.index`)">
                                <router-link :to="{ name: `inventory-management.stock-level-perstore.index` }">Stock Level Per Store</router-link>
                            </li>
                            <li class="border-b hover:bg-gray-400"  v-if="$root.checkAuth(`inventory-management.stock-level-perstore.index`)">
                                <router-link :to="{ name: `inventory-management.stock-level-perstore.indexfilter` }">Stock Level Per Store with Type Filter</router-link>
                            </li>
                            <li class="border-b hover:bg-gray-400">
                                <router-link :to="{ name: `inventory-management.stock-transactions.index` }">Stock Transactions</router-link>
                            </li> 
                            <li class="border-b hover:bg-gray-400">
                                <router-link :to="{ name: `inventory-management.stock-price-list.index` }">Price List</router-link>
                            </li> 
                            <li class="border-b hover:bg-gray-400">
                                <router-link :to="{ name: `inventory-management.stock-reorder-level.index` }">Stock Reorder Level</router-link>
                            </li>
                            <li class="border-b hover:bg-gray-400">
                                <router-link :to="{ name: `inventory-management.stock-with-expiry.index` }">Item Stock Expiry</router-link>
                            </li>
                        </vue-context>
                    </div>
                </div>
            </div>
        </template>
    </tail-base-layout>
</template>
